import {action, makeAutoObservable} from "mobx"
import LongActionStatusApi from "../../api/LongActionStatusApi"
import {AxiosPromise} from "axios"
import {ActionAnswer} from "../../utils/RequestsHelper"


export default class LongActionStatus {
    private _process_id: number | undefined
    private _waitsUntilTaskStarted = 0
    private _onSuccess?: () => void
    private _action: string
    private _interval: any
    private start_request: () => AxiosPromise<ActionAnswer<{ processId: number, text: string }>>

    constructor(params: {
        start: () => AxiosPromise<ActionAnswer<{ processId: number, text: string }>>,
        last_ended_date?: string,
        success?: () => void,
        action: string
    }) {
        makeAutoObservable(this)
        this.start_request = params.start
        this._onSuccess = params.success
        this._last_ended_date = params.last_ended_date
        this._action = params.action
    }

    private _is_running = false
    private _done = false

    get is_running() {
        return this._is_running
    }

    private _last_ended_date: string | undefined

    get last_ended_date(): string | undefined {
        return this._last_ended_date
    }

    private _text: string = ""

    get text(): string {
        return this._text
    }

    start() {
        this._is_running = true
        this._done = false
        this.start_request().then(response => {
            const data = response.data.data
            this._process_id = data.processId
            this._text = data.text
            // this.update()
            this._interval = setInterval(() => this.update(), 1000)
        })
    }

    update() {
        LongActionStatusApi.status(this._process_id, this._action).then(action("updateTask", (response) => {
            const data = response.data.data
            if (+data.has_started === 0) {
                if (this._waitsUntilTaskStarted < 240) {
                    this._waitsUntilTaskStarted++
                    this._text = data.text
                    // setTimeout(() => this.update(), 500)
                } else {
                    this._text = "Не удалось начать выполнять задачу. Возможно не установлен CRON heartbeat"
                }
            } else {
                if (+data.is_completed === 1) {
                    clearInterval(this._interval)
                    this._is_running = false
                    if (+data.error === 0 && !this._done) {
                        if (this._onSuccess) {
                            this._onSuccess()
                        }
                        this._text = data.text
                        this._last_ended_date = data.end_date
                        this._done = true
                    } else if(+data.error !== 0) {
                        this._text = "Задача завершилась с ошибкой, подробности в логах"
                    }
                } else {
                    this._text = data.text
                    // setTimeout(() => this.update(), 500)
                }
            }
        }))

    }
}